import { Route, Routes } from "react-router-dom"
import { Layout } from "layout/Layout"
import { Request } from "pages/Request/Request"
import { Support } from 'pages/Support/Support'
import { Auth } from "pages/Auth/Auth"
import { Deposit } from "pages/Deposit/Deposit"
import { Claim } from "pages/Claim/Claim"
import { PopupDepositPlaced } from "components/PopupDepositPlaced/PopupDepositPlaced"



export function RouterProvider() {
    return (
        <Routes>
            <Route path="/" element={<Layout />} >
                <Route path="/request" element={<Request />} />
                <Route path="/support" element={<Support />} />
                <Route path="/deposit" element={<Deposit />} />
                <Route path="/claim" element={<Claim />} />
            </Route>
            <Route path="/login" element={<Auth />} />
            <Route path="/signup" element={<Auth />} />
            <Route path="/popup-deposit" element={<PopupDepositPlaced onClose={() => { }} />} />
        </Routes>
    );
}